const state = {
  keyword: "", //搜索关键字
  searchCount:0,
  typeModel: "1,2,3,4,5,6,7,8", //类型
  typeDict: [],
  dateModel: "", //年份时期
  dateDict: null, //年份字典
  dotPos: null,
};

const mutations = {
  SET_keyword: (state, keyword) => {
    state.keyword = keyword;
  },
  SET_searchCount: (state, searchCount) => {
    state.searchCount = searchCount;
  },
  SET_dotPos: (state, dotPos) => {
    state.dotPos = dotPos;
  },
  SET_typeModel: (state, typeModel) => {
    state.typeModel = typeModel;
  },
  SET_dateModel: (state, dateModel) => {
    state.dateModel = dateModel;
  },
  SET_dateDict: (state, dateDict) => {
    state.dateDict = dateDict;
  },
  SET_typeDict: (state, typeDict) => {
    state.typeDict = typeDict;
  },
  SET_CLEAR_SEARCH: (state) => {
    state.keyword = "", //搜索关键字
    state.searchCount = 0;
    state.dotPos = null;
    state.typeModel =  null, //类型
    state.dateDict = null;
    state.typeDict =[],
    state.dotPos = null;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
};
